import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/newsService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { EditorState, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToHTML, convertFromHTML } from "draft-convert";

class TourEditForm extends Form {
  state = {
    preferredDate: new Date(),
    thumbUrl: "",
    imageUrl: "",
    categories: [
      { id: "default", name: "Default" },
      { id: "sports", name: "Sports" },
      { id: "entertainment", name: "Entertainment" },
      { id: "culture", name: "Culture" },
      { id: "travelling", name: "Travelling" },
    ],
    locations: [
      { id: "default", name: "Default" },
      { id: "popular", name: "Popular" },
      { id: "breaking", name: "Breaking" },
      { id: "featured", name: "Featured" },
      { id: "front", name: "Front" },
    ],
    data: {
      category: "",
      location: "",
      title: "",
      short: "",
      author: "",
    },
    editorState: EditorState.createEmpty(),
    errors: {},
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  schema = {
    category: Joi.allow(""),
    location: Joi.allow(""),
    title: Joi.string().required().label("Title"),
    short: Joi.string().required().label("Short"),
    author: Joi.string().required().label("Author"),
  };

  onChangeThumbnail = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ thumbUrl: files[0] });
    //this.createImage(files[0]);
  };

  onChangeImage = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;

      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });

      const dateData = this.mapingData(account);

      this.mapingImagesData(account);

      const plainText = account.description;
      //const content = ContentState.createFromText(plainText);

      const editorState = EditorState.createWithContent(
        convertFromHTML(plainText)
      );

      this.setState({
        thumbUrl: account.thumbnail,
        imageUrl: account.image,
        editorState: editorState,
        preferredDate:
          dateData.preferredDate != "01/01/1970" &&
          dateData.preferredDate != undefined &&
          dateData.preferredDate != ""
            ? new Date(dateData.preferredDate)
            : "",
      });

      this.setState({ data: this.mapToViewModel(account) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapingData(account) {
    return {
      preferredDate: account.news_date,
    };
  }

  mapingImagesData(account) {
    return {
      thumbUrl: account.thumbnail,
      imageUrl: account.image,
    };
  }

  mapToViewModel(account) {
    return {
      category: account.category,
      location: account.location,
      title: account.title,
      short: account.short,
      author: account.author,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const text = convertToHTML(this.state.editorState.getCurrentContent());

      let formData = new FormData();
      formData.append("category", this.state.data.category);
      formData.append("location", this.state.data.location);
      formData.append("title", this.state.data.title);
      formData.append("short", this.state.data.short);
      formData.append("description", text);
      formData.append("author", this.state.data.author);
      formData.append("thumbnail", this.state.thumbUrl);
      formData.append("image", this.state.imageUrl);

      var event = new Date(this.state.preferredDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("news_date", date);
      formData.append("_method", "PUT");

      await updateSingle(formData, ledgerTypeId);
      this.setState({ blocking: false });
      toast.success("News has been updated successfully.");
      this.props.history.push("/web/news");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  handleChangePreferredDate = (date) => {
    this.setState({
      preferredDate: date,
    });
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    const { editorState } = this.state;
    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle
          title="Update News"
          icon="tag"
          color="white"
          iconPath={dashboardIcon}
        />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "70%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Update news</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderSelect(
                      "category",
                      "Category",
                      this.state.categories
                    )}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderSelect(
                      "location",
                      "Location",
                      this.state.locations
                    )}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("title", "Title", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>
                      <b>Short</b>
                    </label>
                    {this.renderTextarea("short", "Short", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <Editor
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      wrapperStyle={{ height: "auto" }}
                      editorStyle={{
                        height: "400px",
                        border: "1px solid #eeeeee",
                        padding: "7px",
                        paddingTop: "0px",
                      }}
                      toolbarStyle={{}}
                      editorState={editorState}
                      onEditorStateChange={this.onEditorStateChange}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("author", "Author", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>Thumbnail</label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeThumbnail}
                    />
                    <div className="imgPreview">
                      {this.state.thumbUrl ? (
                        <img
                          className="add_imagem"
                          name="add_imagem"
                          height="40"
                          src={
                            process.env.REACT_APP_BACKEND_URL +
                            "/storage/" +
                            this.state.thumbUrl
                          }
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>Image</label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeImage}
                    />
                    <div className="imgPreview">
                      {this.state.imageUrl ? (
                        <img
                          className="add_imagem"
                          name="add_imagem"
                          height="40"
                          src={
                            process.env.REACT_APP_BACKEND_URL +
                            "/storage/" +
                            this.state.imageUrl
                          }
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16">
                    <label>
                      <b>News Date</b>
                    </label>
                    <br />
                    <DatePicker
                      selected={this.state.preferredDate}
                      onChange={this.handleChangePreferredDate}
                    />
                    <br />
                    <small>(day/month/year)</small>
                  </Table.Cell>
                  <Table.Cell width="8"></Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Update")}
                    <Link to="/web/news" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default TourEditForm;
